export const ROUTES = {
  // Auth Routes
  ROOT: "/",
  SIGN_IN: "/signin",
  SIGN_UP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  VERIFY_OTP: "/verify-otp",
  CHANGE_PASSWORD: "/change-password",

  // Public Routes
  HOME: "/home",
  CONTACT: "/contact",
  FAQS: "/faqs",
  MINER_INFO: "/miner-info",
  MINER_INFO_SECOND: "/miner-info-second",
  TERMS_CONDITIONS: "/terms-conditions",
  PRIVACY_POLICY: "/privacy-policy",

  // Dashboard Routes
  DASHBOARD: "/dashboard",
  MINER_DETAILS: "/miner-details",
  EARNING_HISTORY: "/earning-history",
  MY_WALLET: "/my-wallet",
  WITHDRAWAL_HISTORY: "/withdrawal-history",
  REFERRAL_PROGRAM: "/referral-program",
  INVITATION_HISTORY: "/invitation-history",
  SETTINGS: "/settings",
  CUSTOMER_SUPPORT: "/customer-support",
};

/**
 * Route sections for navigation highlighting
 */
export const ROUTE_SECTIONS = {
  DASHBOARD: [
    ROUTES.DASHBOARD,
    ROUTES.MINER_DETAILS,
    ROUTES.EARNING_HISTORY,
    ROUTES.MY_WALLET,
    ROUTES.WITHDRAWAL_HISTORY,
    ROUTES.REFERRAL_PROGRAM,
    ROUTES.INVITATION_HISTORY,
    ROUTES.SETTINGS,
    ROUTES.CUSTOMER_SUPPORT,
  ],
};
